export const handleRyderLivescoringSocketResponse = (socketResponse, varEnv, setStateData) => {
    if (
        socketResponse &&
        socketResponse.env === varEnv
    ) {
        setStateData(socketResponse.data)
    }
}